import { useScreenFilters } from "@/hooks/useScreenFilters";
import { useEffect, useState } from "react";

export function ScreenFilterLayer() {
  const { getFilterClasses, enabled, getActiveFiltersCount, toggleEnabled, toggleFilter } = useScreenFilters();
  const [isReady, setIsReady] = useState(false);
  
  // Set ready immediately for instant effect activation
  useEffect(() => {
    setIsReady(true);
  }, []);
  
  const filterClasses = getFilterClasses();
  
  // Enhanced debug logging
  console.log('ScreenFilterLayer render:', { 
    enabled, 
    activeFiltersCount: getActiveFiltersCount(),
    filterClasses,
    isReady,
    cssLoaded: document.querySelector('style, link[rel="stylesheet"]') !== null
  });
  
  // Render filter layer immediately if any filters are active
  if (!filterClasses || filterClasses.trim() === '') {
    console.log('ScreenFilterLayer: not rendering', { enabled, filterClasses });
    
    // Debug button - only show in development
    if (import.meta.env.DEV) {
      return (
        <div className="fixed top-4 right-4 z-[100000] bg-black text-white p-2 rounded text-xs">
          <div>Debug: Effects {enabled ? 'ON' : 'OFF'}</div>
          <div>Active: {getActiveFiltersCount()}</div>
          <button 
            onClick={() => {
              console.log('Debug toggle enabled clicked');
              toggleEnabled();
            }}
            className="bg-blue-500 px-2 py-1 rounded mt-1 mr-1"
          >
            Toggle Master
          </button>
          <button 
            onClick={() => {
              console.log('Debug toggle CRT clicked');
              toggleFilter('crt');
            }}
            className="bg-green-500 px-2 py-1 rounded mt-1"
          >
            Toggle CRT
          </button>
        </div>
      );
    }
    
    return null;
  }

  return (
    <div 
      className={`fixed inset-0 pointer-events-none z-[99999] ${filterClasses}`}
      style={{
        // CSS-in-JS fallback for critical positioning
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
        zIndex: 99999,
        willChange: 'opacity, transform'
      }}
      data-active-filters={getActiveFiltersCount()}
      data-testid="screen-filter-layer"
    />
  );
}